import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const DOpopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        {/* <h1 className="mb-3">Bank Details</h1> */}
                    </div>

                    <div className="table-responsive">
                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4">Category</th>
                                    <th className="min-w-100px">Item</th>
                                    <th className="min-w-100px">Grade</th>
                                    <th className="min-w-100px">Color</th>
                                    <th className="min-w-100px">Packaging</th>
                                    <th className="min-w-100px">Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0].itemName || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0].grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0].color || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0].packagingType || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0].quantity || 'N/A'} Kg
                                        </span>
                                    </td>

                                </tr>
                            </tbody>
                        </table> */}

                        <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Order Details
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            width: "30%",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Category
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Item
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Grade
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Color
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Packaging
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.packagingType || 'N/A'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Quantity
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {user?.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'} Kg
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};